<template>
    <div>
      <slot name="btn" v-bind="{toShow}">
        <el-button type="text" @click="toShow" size="mini" style="padding: 0;font-size: 12px;">{{$t(btnTxt)}}</el-button>
      </slot>
      <l-dialog
            :visible.sync="visible"
            :title="$t(title)"
            :hasBtns="false"
            :height="height"
            :width="width"
        >
          <div style="height: 100%;overflow: auto;">
              <l-rich v-model="value"></l-rich>
          </div>
      </l-dialog>
    </div>
</template>

<script>
import "quill/dist/quill.snow.css";
export default {
    name: 'l-rich-dg',
    props: {
      value: {
        default: ''
      },
      height: {
        default: 700
      },
      width: {
        default: 950
      },
      btnTxt: {
        default: '查看详情'
      },
      title: {
        default: '详情'
      }
    },
    data() {
        return {
          visible: false
        };
    },
    computed: {
    },
    mounted() {
        
    },
    methods: {
        toShow () {
          this.visible = true
        }
    }
}
</script>
<style scoped lang="less">
    @import "../../lrEditor/_src/index.less";
    .rich-box {
      height: 100%;
    }
</style>